import { withInstall } from '@tav-ui/utils/with-install'
import Dropdown from './src/dropdown.vue'
const TaDropdown = withInstall(Dropdown)
export { TaDropdown }
export default TaDropdown
export * from './src/types'
